// console.log(process.env.REACT_APP_BACKEND_URL)
export const backend_url = process.env.REACT_APP_BACKEND_URL || "http://127.0.0.1:5000"